import "antd/es/modal/style";
import _Modal from "antd/es/modal";
var _excluded = ["getContainer"],
    _excluded2 = ["content", "onCancel", "onOk"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useContext } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import classnames from 'classnames';
import { CrossOutlined } from 'iglooicon';
import Button from '../button';
import Form from '../form';
import { LocaleContext, LocaleProvider } from '../locale';
import { staticLang } from '../locale/format-message';
import './style/index.less';
var modals = [];

var IglooModal = function IglooModal(props) {
  var formRef = useRef();

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var onOk = props.onOk,
      _props$okText = props.okText,
      okText = _props$okText === void 0 ? formatMessage({
    id: 'OK'
  }) : _props$okText,
      _props$okType = props.okType,
      okType = _props$okType === void 0 ? 'primary' : _props$okType,
      _props$okButtonProps = props.okButtonProps,
      okButtonProps = _props$okButtonProps === void 0 ? {} : _props$okButtonProps,
      onCancel = props.onCancel,
      _props$cancelText = props.cancelText,
      cancelText = _props$cancelText === void 0 ? formatMessage({
    id: 'Cancel'
  }) : _props$cancelText,
      _props$cancelButtonPr = props.cancelButtonProps,
      cancelButtonProps = _props$cancelButtonPr === void 0 ? {} : _props$cancelButtonPr,
      footer = props.footer,
      width = props.width,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'normal' : _props$mode,
      formConfig = props.formConfig,
      _props$formProps = props.formProps,
      formProps = _props$formProps === void 0 ? {} : _props$formProps,
      _props$limitHeight = props.limitHeight,
      limitHeight = _props$limitHeight === void 0 ? true.valueOf : _props$limitHeight,
      children = props.children;

  var handleOk = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var _formRef$current, value, rst, _formRef$current2;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof onOk !== 'function')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(mode === 'form')) {
                _context.next = 17;
                break;
              }

              _context.next = 5;
              return (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.getValues();

            case 5:
              value = _context.sent;
              rst = null;
              _context.prev = 7;
              _context.next = 10;
              return onOk(value);

            case 10:
              rst = _context.sent;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](7);

              if (Array.isArray(_context.t0)) {
                (_formRef$current2 = formRef.current) === null || _formRef$current2 === void 0 ? void 0 : _formRef$current2.setErrors(_context.t0);
              }

            case 16:
              return _context.abrupt("return", rst);

            case 17:
              return _context.abrupt("return", onOk(e));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 13]]);
    }));

    return function handleOk(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return _jsx(_Modal, _objectSpread(_objectSpread({}, props), {}, {
    className: classnames('igloo-modal', props.className, {
      'igloo-modal-no-footer': footer === null,
      'igloo-modal-limit-height': mode !== 'form' && limitHeight,
      'igloo-modal-no-limit-height': !limitHeight
    }),
    closeIcon: _jsx(CrossOutlined, {
      style: {
        fontSize: 24,
        color: '#666666'
      }
    }),
    footer: footer === undefined ? _jsxs("div", {
      className: "igloo-modal-footer-btns",
      children: [_jsx(Button, _objectSpread(_objectSpread({
        onClick: onCancel
      }, cancelButtonProps), {}, {
        className: classnames('igloo-modal-footer-button', cancelButtonProps.className),
        children: cancelText
      })), _jsx(Button, _objectSpread(_objectSpread({
        type: okType
      }, okButtonProps), {}, {
        className: classnames('igloo-modal-footer-button', okButtonProps.className),
        onClick: handleOk,
        children: okText
      }))]
    }) : footer,
    width: width || 'noStyleWidth',
    children: formConfig ? _jsx(Form, _objectSpread({
      config: formConfig,
      showSubmitButton: false,
      ref: formRef
    }, formProps)) : children
  }));
};

var modalFunction = function modalFunction(_ref2) {
  var getContainer = _ref2.getContainer,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var ele = document.createElement('div');
  var container;

  if (typeof getContainer === 'string') {
    container = document.querySelector(getContainer);
  }

  if (typeof getContainer === 'function') {
    container = getContainer();
  }

  if (getContainer instanceof HTMLElement) {
    container = getContainer;
  }

  if (!container) {
    container = document.body;
  }

  container.appendChild(ele);

  var renderModal = function renderModal(_ref3) {
    var content = _ref3.content,
        _onCancel = _ref3.onCancel,
        _onOk = _ref3.onOk,
        rest = _objectWithoutProperties(_ref3, _excluded2);

    render(_jsx(LocaleProvider, {
      currentLang: staticLang.current,
      children: _jsx(IglooModal, _objectSpread(_objectSpread({}, rest), {}, {
        visible: true,
        onCancel: function onCancel() {
          _onCancel && _onCancel.apply(void 0, arguments);
          destroy();
        },
        onOk: function onOk() {
          var rst = _onOk && _onOk.apply(void 0, arguments);

          if (rst instanceof Promise) {
            rst.then(function () {
              destroy();
            });
          } else {
            destroy();
          }

          return rst;
        },
        children: content
      }))
    }), ele);
  };

  var destroy = function destroy() {
    unmountComponentAtNode(ele);

    try {
      container.removeChild(ele);
    } catch (_unused) {
      console.error('cannot remove modal element');
    }
  };

  var update = function update(newProps) {
    renderModal(newProps);
  };

  renderModal(rest);
  modals.push(destroy);
  return {
    destroy: destroy,
    update: update
  };
};

IglooModal.confirm = modalFunction;
IglooModal.warning = modalFunction;
IglooModal.error = modalFunction;
IglooModal.success = modalFunction;
IglooModal.info = modalFunction;

IglooModal.noFooter = function (props) {
  return modalFunction(_objectSpread(_objectSpread({}, props), {}, {
    footer: null,
    className: classnames('igloo-modal-no-footer', props.className)
  }));
};

IglooModal.destroyAll = function () {
  modals.forEach(function (destroy) {
    return destroy();
  });
};

export default IglooModal;